<top-nav-bar [navTitle]="navTitle" [showButtons]="true" [isGrayBackground]="true">
  <ng-container top-nav-bar-button>
    <create-okr-dropdown-button *hasPermissions="'ManageGoals'" [showNewDesign]="true"></create-okr-dropdown-button>
  </ng-container>
</top-nav-bar>
